GroupDetailToolbarService = ($http ,$q) ->
  leaveGroup: (params) ->
    url = "/api/users/leave_group.json?user_id=#{params.user_id}&group_id=#{params.group_id}"
    $http.delete(url)

GroupDetailToolbarService.$inject = [
  '$http'
  '$q'
]

module.exports = GroupDetailToolbarService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/groups/group-detail-toolbar/group-detail-toolbar-service.coffee